import { useEffect } from 'react';

import { useLoggedInEmployeeId } from '~/components/Auth';
import { useSelectedEmployeeContext } from '~/components/SelectedEmployee/context';

export const useResetSelectedEmployeeId = () => {
  const loggedInEmployeeId = useLoggedInEmployeeId();
  const { selectedEmployeeId, setSelectedEmployeeId } =
    useSelectedEmployeeContext();

  useEffect(() => {
    const isSelectedLoggedInUser = selectedEmployeeId === loggedInEmployeeId;

    if (!isSelectedLoggedInUser) {
      setSelectedEmployeeId(loggedInEmployeeId);
    }
  }, [selectedEmployeeId, setSelectedEmployeeId, loggedInEmployeeId]);
};
